import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/layout/ProtectedRoute";
import { BlockedModuleGuard } from "../components/layout/BlockedModuleGuard";
import { OwnerOnlyRoute } from "../components/layout/RoleGuard";
import FranchisePage from "../pages/FranchisePage";
import OwnerAlertsPage from "../pages/OwnerAlertsPage";
import CommandCenterPage from "../pages/CommandCenterPage";
import CommandCenterTenantPage from "../pages/CommandCenterTenantPage";
import SettingsPage from "../pages/SettingsPage";
import V2DemoRuntimePage from "../pages/V2DemoRuntimePage";

/**
 * All routes restricted to OwnerOnlyRoute.
 * Called as a function {OwnerRoutes()} inside <Routes> so React Router
 * sees the Fragment children directly and processes them as Route elements.
 */
export default function OwnerRoutes() {
  return (
    <>
      <Route
        path="/franchise"
        element={<ProtectedRoute><OwnerOnlyRoute><BlockedModuleGuard module="franchise"><FranchisePage /></BlockedModuleGuard></OwnerOnlyRoute></ProtectedRoute>}
      />
      <Route
        path="/owner-alerts"
        element={<ProtectedRoute><OwnerOnlyRoute><OwnerAlertsPage /></OwnerOnlyRoute></ProtectedRoute>}
      />
      <Route
        path="/command-center"
        element={<ProtectedRoute><OwnerOnlyRoute><CommandCenterPage /></OwnerOnlyRoute></ProtectedRoute>}
      />
      <Route
        path="/command-center/:tenantId"
        element={<ProtectedRoute><OwnerOnlyRoute><CommandCenterTenantPage /></OwnerOnlyRoute></ProtectedRoute>}
      />
      <Route
        path="/settings"
        element={<ProtectedRoute><OwnerOnlyRoute><SettingsPage /></OwnerOnlyRoute></ProtectedRoute>}
      />
      <Route
        path="/settings/subscription"
        element={<ProtectedRoute><OwnerOnlyRoute><SettingsPage /></OwnerOnlyRoute></ProtectedRoute>}
      />
      <Route
        path="/v2-demo-runtime"
        element={<ProtectedRoute><OwnerOnlyRoute><V2DemoRuntimePage /></OwnerOnlyRoute></ProtectedRoute>}
      />
    </>
  );
}
